import { useEffect, useMemo, useState } from "react";
import oMenu from "o-menu";
import { renderToStaticMarkup } from "react-dom/server";
import { Circle, GeoJSON, Marker, Pane, Polyline, Popup, Rectangle, Tooltip } from "react-leaflet";
import { divIcon, DomEvent } from "leaflet";

import { Card, Stack, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { Box, color } from "@mui/system";
import { changeSelectLocFor, changeSelectLocMode, changeShowAddStationModal, changeShowContext } from "Redux/mapSlice";
import { useDispatch } from "react-redux";
import { OperationNames } from "Types/operation";
import { StationType } from "Types/station";
import { changeOperation } from "Redux/operationSlice";
import { toggleVisibility as toggleStations } from "Redux/stationsSlice";
import { changeModal } from "Redux/modalSlice";

const ICON_SIZE = 22;

export default function ContextMenu() {
  let omenu: any;

  const dispatch = useDispatch();
  const { showContext, contextPosition, closeContext } = useAppSelector((state) => state.map);
  const { visible: stationsVisibility } = useAppSelector((state) => state.stations);
  const [activeMenuIndex, setActiveMenuIndex] = useState<null | number>(null);
  const [selectedItem, setSelectedItem] = useState();

  const handle2 = (ev: any) => {
    omenu.close("j");
    // dispatch(changeShowContext(true));
  };

  const handleClickType = (operationName: OperationNames, type: StationType) => {
    dispatch(changeOperation({ name: operationName, type }));

    if (!stationsVisibility) {
      dispatch(toggleStations());
    }
    setActiveMenuIndex(null);
  };

  const handle = (ev: any) => {
    omenu.open("j", {
      slices: [
        {
          content: "j",
          styles: {
            defaults: {
              fill: "blue",
            },
          },
          slices: [
            {
              content: "mmd",
            },
            {
              content: "ddf",
            },
          ],
        },
        {
          data: "create-path",
          content:
            "<div style='text-align:center'><span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-cmbi16-MuiIcon-root' aria-hidden='true'>route</span></div>",
          styles: {
            defaults: {
              fill: "red",
            },
          },
          slices: [
            {
              data: "createPath_bus",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<div style='text-align:center'><span class='material-icons-outlined notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>directions_bus</span></div>",
            },
            {
              data: "createPath_metro",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>directions_transit</span>",
            },
            {
              data: "createPath_taxi",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>local_taxi</span>",
            },
            {
              data: "createPath_train",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>train</span>",
            },
            {
              data: "createPath_bicycle",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>pedal_bike</span>",
            },
            {
              data: "createPath_walking",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>directions_walk</span>",
            },
            {
              data: "behamrah",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content: "<img src='/assets/behamrah-logo.svg' alt='' style='height: 22px;'>",
            },
          ],
        },
        {
          data: "add-station",
          content:
            "<div style='text-align:center'><span class='material-icons-outlined notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' aria-hidden='true'>directions_bus</span></div>",
          styles: {
            defaults: {
              fill: "green",
            },
          },
          slices: [
            {
              data: "addStation_bus",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<div style='text-align:center'><span class='material-icons-outlined notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>directions_bus</span></div>",
            },
            {
              data: "addStation_metro",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>directions_transit</span>",
            },
            {
              data: "addStation_taxi",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>local_taxi</span>",
            },
            {
              data: "addStation_train",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>train</span>",
            },
            {
              data: "addStation_bicycle",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>pedal_bike</span>",
            },
            {
              data: "addStation_walking",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content:
                "<span class='material-icons notranslate MuiIcon-root MuiIcon-fontSizeMedium muirtl-kp9ftd-MuiIcon-root' style='font-size: 23px;' aria-hidden='true'>directions_walk</span>",
            },
            {
              data: "addStation_behamrah",
              slices: [
                {
                  content: "mmd",
                },
              ],
              content: "<img src='/assets/behamrah-logo.svg' alt='' style='height: 22px;'>",
            },
          ],
        },
      ],
    });
  };

  useEffect(() => {
    omenu = oMenu("main3", {
      menu: {
        firstLevelSliceWidth: 70,
        closeMenuOn: "contextmenu",
        innerCircleRadius: 45,
        innerCircleWidth: 40,
        // innerCircleContent: `<div style=width:100px;margin:auto;margin-top:60px;text-align:center>nshn<div/>`,
      },
      nthSlice: {
        contentSize: 22,
        iconDistanceFromInnerCircle: 5,
        parentFillMode: -0.3,
        styles: {
          contentContainer: {
            fontSize: 22,
            color: "#efefef",
          },
        },
      },
      slice: {
        onClick: () => console.log("gilam8"),
        contentSize: 30,
        iconDistanceFromInnerCircle: 10,
        styles: {
          contentContainer: {
            fontSize: 30,
            color: "#efefef",
          },
        },
      },
      // close: function (ev: any) {
      //   console.log("fsf");
      // },
    });
    if (closeContext) {
      omenu.close("j");
    }
    omenu.on("sliceClick", (ev: any) => {
      if (ev.data?.split("_")[0] === "createPath") {
        handleClickType("create-path", ev.data?.split("_")[1]);
      }
      if (ev.data?.split("_")[0] === "addStation") {
        dispatch(changeSelectLocMode(1));
        dispatch(changeModal({ status: "disable", data: { lat: 30, lng: 50, type: ev.data?.split("_")[1] } }));
        dispatch(changeSelectLocFor("add-station"));
      }
    });
    if (showContext) {
      setTimeout(() => handle("j"), 300);
      dispatch(changeShowContext(false));
    }
    // if (!showContext) {
    //   setTimeout(() => handle2("j"), 300);
    //   dispatch(changeShowContext(false));
    // }
  }, [showContext, closeContext]);

  return (
    <>
      <div id="main3" style={{ opacity: "0" }} />
      <Pane style={{ zIndex: 16 }} name="context-menu-1">
        <Rectangle
          bounds={[
            [0, 0],
            [0, 0],
          ]}
          pathOptions={{ color: "black" }}
          opacity={1}
        >
          <Tooltip offset={[0, 0]} position={contextPosition} permanent opacity={1}>
            <div id="main3" style={{ pointerEvents: "auto" }} />
          </Tooltip>
        </Rectangle>
      </Pane>
    </>
  );
}
